import type {ReactNode} from 'react'

export type BlockContainerProps = {
  eyebrow?: string
  headline?: string
  subhead?: string
  children: ReactNode
}

export const BlockContainer = ({eyebrow, headline, subhead, children}: BlockContainerProps) => {
  const hasHeader = Boolean(eyebrow) || Boolean(headline) || Boolean(subhead)

  return (
    <div className="relative rounded-block border border-green-neon/40 bg-green-dark/[35%] p-5 text-green-mist shadow-glass-glow backdrop-blur-[14px] sm:p-10">
      {hasHeader && (
        <div className="mb-6">
          {eyebrow && (
            <span className="mb-3 block text-[11px] font-semibold uppercase tracking-[0.08em] text-green-neon">
              {eyebrow}
            </span>
          )}
          {headline && <h2 className="m-0 text-28 font-bold leading-[1.15]">{headline}</h2>}
          {subhead && <p className="mt-1 text-15 text-green-mist-dim">{subhead}</p>}
        </div>
      )}
      {children}
    </div>
  )
}
